import { FieldContext, ValidationResult } from "@angular/forms/signals";

export function validateUrl(context: FieldContext<string>): ValidationResult {
  const value = context.value();
  if (!value) return null;
  try {
    new URL(value);
    return null;
  } catch {
    return { kind: "invalidUrl", message: "common.invalid_url" };
  }
}
